import styled from 'styled-components';
import { Image, TimeDelayMsg, AnimationBar } from '../../LoadingSplash';
import splashImg from '../../../img/splash.gif';
import { useTranslation } from 'react-i18next';

const MobileSplashWrapper = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  width: 316px;
  height: 280px;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MobileMessageArea = styled.div`
  width: 100%;
  height: 19px;
  padding-top: 24px;
  text-align: center;
  font-size: 13px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2f3133;
`;

export default function LoadingSplashMobile({ isShowAnimationBar, isSHowTimeDelayMsg }) {
  const { t } = useTranslation();
  return (
    <MobileSplashWrapper>
      <Image width="316px" height="190px" src={splashImg} alt="splash" />
      {isShowAnimationBar && <AnimationBar width="70px" height="28px" />}
      <MobileMessageArea>
        <TimeDelayMsg visible={isSHowTimeDelayMsg}>
          {t('LoadingSplash.TimeDelayMessage')}
        </TimeDelayMsg>
      </MobileMessageArea>
    </MobileSplashWrapper>
  );
}
